import { forwardRef, useMemo } from "react";

import { usePermissions } from "Flocknote/apiHooks";

import ButtonGroupContainer from "NavBar/components/FloatingButtonPanel/ButtonGroupContainer";
import { delayIn } from "NavBar/components/FloatingButtonPanel/constants";
import {
  navSectionKeys,
  useActiveSectionKey,
  useIsInitialized,
  useNavBarIsFullyLoaded,
} from "NavBar/navBarStore";

import FnrOpacityToggle from "UI/FnrOpacityToggle";

import AllButton from "./AllButton";
import NewButton from "./NewButton";
import SearchButton from "./SearchButton";

const FloatingButtonPanel = forwardRef((props, ref) => {
  const [{ canManageGroups }] = usePermissions();

  const [activeSectionKey] = useActiveSectionKey();
  const isInitialized = useIsInitialized();
  const isFullyLoaded = useNavBarIsFullyLoaded();

  const isGroupsActive = useMemo(
    () => activeSectionKey === navSectionKeys.groups,
    [activeSectionKey]
  );

  return (
    <FnrOpacityToggle
      show={isGroupsActive && isInitialized && isFullyLoaded}
      delayIn={delayIn}
    >
      <ButtonGroupContainer ref={ref}>
        <AllButton />
        <SearchButton />
        {canManageGroups && <NewButton />}
      </ButtonGroupContainer>
    </FnrOpacityToggle>
  );
});

export default FloatingButtonPanel;
